const publicUrl = process.env.PUBLIC_URL || '';
export const CHART_BUNDLE_URL = `${publicUrl}/chart-bundle/index.html`;
